export type RGBAColor = [number, number, number, number];

/**
 * Thang màu độ sâu ngập — tông lạnh (nước) trên nền bản đồ sáng: nông → sâu (teal → lam → lam đậm).
 * Dùng chung `floodDepthRgba`, lưới Deck, polygon 2D, legend.
 */
export const FLOOD_DEPTH_COLORS: RGBAColor[] = [
  [153, 233, 216, 205],
  [45, 212, 191, 215],
  [56, 189, 248, 225],
  [37, 99, 235, 238],
  [30, 64, 175, 255],
];

export const HEATMAP_COLORS: RGBAColor[] = [
  [1, 152, 189, 100],
  [73, 227, 206, 150],
  [216, 254, 181, 180],
  [254, 237, 177, 200],
  [254, 173, 84, 220],
  [209, 55, 78, 255],
];

export const FLOOD_DEPTH_LABELS = ['0 - 0.5m', '0.5 - 1m', '1 - 2m', '2 - 3m', '> 3m'] as const;
